// extracted by mini-css-extract-plugin
export var boxItems = "_ch-1";
export var boxItemsLg = "_ch-2";
export var button = "_ch-7";
export var buttonHoverless = "_ch-9";
export var buttonLg = "_ch-8";
export var filterGroupBox = "_ch-0";
export var icon = "_ch-3";
export var iconSecondary = "_ch-6";
export var iconWrapper = "_ch-4";
export var iconWrapperLg = "_ch-5";
export var truncatedLabel = "_ch-a";